export enum ValidationTypes {
  number = 'number',
  int = 'int',
  string = 'string',
  point = 'point',
}

export interface InputProps {
  initialState?: string;
  decimals?: number;
  minValue?: number;
  maxValue?: number;
  type: ValidationTypes;
}

export interface IValidateParams {
  value: string;
  isInteger?: boolean;
  decimals?: number;
}
